import { translateInComponent } from 'infras/i18n';
import translations from '../i18n.json';

import { SyntheticEvent, useMemo } from 'react';
import styled from '@emotion/styled';
import Link from 'presentations/views/components/atoms/Link';
import {
  borderRadius,
  fontSize,
  fontWeight,
  mediaMax,
  spacing,
} from 'presentations/views/styles';
import { primary, white, whiteFix } from 'presentations/views/styles/color';
import { setEvent } from 'presentations/views/helpers/analytics';
import Image from 'presentations/views/components/atoms/Image';
import { ProductType } from 'domains/models/blog_post/productType';
import { imagePath } from 'presentations/assets';
import { getLandingPageUrl } from '..';

interface Props {
  productType: ProductType;
  position?: string;
  isHideClose?: boolean;
  className?: string;
  adId?: string | null;
  name?: string;
}

export default function (props: Props) {
  const t = translateInComponent(translations);
  const eventName = `click ${props.name || 'resource'} banner`;
  const targetUrl = useMemo(() => {
    return getLandingPageUrl(props.productType);
  }, [props.productType]);
  const onClick = (e: SyntheticEvent<HTMLDivElement>) => {
    e.preventDefault();
    setEvent(eventName, {
      position: props.position || 'sub_top',
      contentType: 'default',
    });
    window.open(targetUrl);
  };
  const onClickLink = (e: SyntheticEvent<HTMLAnchorElement>) => {
    e.stopPropagation();
    setEvent(eventName, {
      position: props.position || 'sub_top',
      contentType: 'default',
    });
  };

  return (
    <SubAd onClick={onClick}>
      <FooterAdBackgroundImage gridColor={'white'} />
      <Link href={targetUrl} onClick={onClickLink}>
        <Image
          src="logo/www_white.svg"
          alt={t('Jicoo')}
          width={120}
          height={30}
        />
      </Link>
      <SubAdTitle>
        <LinkText href={targetUrl} onClick={onClickLink}>
          {t(`title_${props.productType}`)}
        </LinkText>
      </SubAdTitle>
      <SubAdDescription>
        <LinkText href={targetUrl} onClick={onClickLink}>
          {t(`description_${props.productType}`)}
        </LinkText>
      </SubAdDescription>
      <SubAdLinkWrap
        href={targetUrl}
        onClick={onClickLink}
        campaign={{
          medium: props.name || 'resource',
          source: 'jicoo',
          campaign: 'signup',
          content: 'sub_ad',
        }}
        withoutNextLink
      >
        {t('try it for free')}
      </SubAdLinkWrap>
    </SubAd>
  );
}

const AdTitle = styled.div`
  font-weight: ${fontWeight('bold')};
  color: ${white};
`;
const AdDescription = styled.p`
  font-weight: ${fontWeight('bold')};
  color: ${white};
`;
const LinkWrap = styled(Link)`
  color: ${white};
  border: 1px solid ${whiteFix};
  border-radius: ${borderRadius(6)};
  font-weight: ${fontWeight('bold')};
  font-size: ${fontSize(14)};
  cursor: pointer;
  &:hover {
    background: rgba(255, 255, 255, 0.16);
  }
`;

const SubAd = styled.div`
  position: relative;
  background-color: ${primary};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${spacing(24)} ${spacing(16)};
  text-align: center;
  cursor: pointer;
`;
const SubAdTitle = styled(AdTitle)`
  margin-top: ${spacing(16)};
  font-size: ${fontSize(20)};
  letter-spacing: -0.01em;
  ${mediaMax.tablet} {
    font-size: ${fontSize(18)};
  }
`;
const SubAdDescription = styled(AdDescription)`
  margin-top: ${spacing(16)};
  white-space: pre-wrap;
  font-size: ${fontSize(12)};
  ${mediaMax.tablet} {
    font-size: ${fontSize(12)};
    white-space: normal;
  }
`;
const SubAdLinkWrap = styled(LinkWrap)`
  margin-top: ${spacing(16)};
  padding: ${spacing(8)} ${spacing(48)};
  color: ${whiteFix};
  width: 100%;
`;

const FooterAdBackgroundImage = styled.div<{ gridColor: string }>`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  /* background-image: url(${(props) =>
    imagePath(`ads/bg_line_${props.gridColor}.svg`)}); */
  background-repeat: repeat;
  opacity: 0.1;
`;
const LinkText = styled(Link)`
  color: ${whiteFix};
`;
